import { useEffect, useState } from "react";
import { Box, Button, Tab, Tabs, Typography } from "@mui/material";
import { styled } from "@mui/system";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { downloadProject, fetchProjectPdf } from "../../api/handleProjects";
import { FINAL_DOCUMENTS } from "../../utils/finalDocuments";

const DownloadButton = styled(Button)(({ theme }) => ({
  width: "100%",
  marginTop: theme.spacing(2),
  backgroundColor: "#0072C6",
  color: "#ffffff",
  "&:hover": {
    backgroundColor: "#005B9A",
  },
  borderRadius: "4px",
}));

const PdfPreviewBox = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "500px",
  border: "1px solid #ccc",
  borderRadius: "4px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#f9f9f9",
  marginTop: theme.spacing(2),
}));

// Previsualizacion de los tres documentos de la entrega final, una pestaña por
// documento. Con `group` sabe de antemano cuales faltan y no los pide; sin el
// (el tutor solo tiene el id), los pide igual y un error es "no entregado".
const FinalDocumentsPreview = ({ groupId, groupNumber, periodId, user, group }) => {
  const [selected, setSelected] = useState(FINAL_DOCUMENTS[0].key);
  const [pdfUrl, setPdfUrl] = useState(null);

  const current = FINAL_DOCUMENTS.find((d) => d.key === selected);
  const knownMissing = !!group && !group[current.dateField];

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setPdfUrl(null);
      if (knownMissing) {
        setPdfUrl("failed");
        return;
      }
      try {
        const url = await fetchProjectPdf(groupId, user, periodId, "final", selected);
        if (!cancelled) setPdfUrl(url);
      } catch (error) {
        console.error(`Error al cargar la previsualización de ${selected}:`, error);
        if (!cancelled) setPdfUrl("failed");
      }
    };
    if (groupId && periodId) load();
    return () => {
      cancelled = true;
    };
  }, [groupId, periodId, user, selected, knownMissing]);

  const download = async () => {
    try {
      await downloadProject(groupId, user, periodId, "final-project", groupNumber, selected);
    } catch (error) {
      console.error("Error al descargar el archivo:", error);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={selected}
        onChange={(event, value) => setSelected(value)}
        variant="fullWidth"
      >
        {FINAL_DOCUMENTS.map((d) => (
          <Tab
            key={d.key}
            value={d.key}
            label={d.label}
            iconPosition="start"
            icon={
              !group ? undefined : group[d.dateField] ? (
                <CheckCircleIcon fontSize="small" color="success" />
              ) : (
                <RadioButtonUncheckedIcon fontSize="small" color="disabled" />
              )
            }
          />
        ))}
      </Tabs>
      {pdfUrl === "failed" ? (
        <Typography align="center" sx={{ marginTop: 2 }}>
          {current.label}: no entregado.
        </Typography>
      ) : (
        <>
          <PdfPreviewBox>
            {pdfUrl ? (
              <iframe
                src={pdfUrl}
                title={`Previsualización de ${current.label}`}
                width="100%"
                height="100%"
                style={{ border: "none" }}
              />
            ) : (
              <Typography>Cargando ...</Typography>
            )}
          </PdfPreviewBox>
          <DownloadButton variant="contained" onClick={download}>
            Descargar {current.label}
          </DownloadButton>
        </>
      )}
    </Box>
  );
};

export default FinalDocumentsPreview;
